import { Button } from '../../../components/DesignSystem/AtomicComponents';
import { OtpRightArrow } from '@/assets/svgExports/OtpRightArrow';
import styles from '../MemberLogin.module.scss';
import { sendWhatsappMessage } from '@/utils/sendWhatsappMessage';

const DesktopView = (props) => {
  const handleMobileInputChange = (e) => {
    props.handleInputChange(
      'phone',
      e.target.value.replace(/[^0-9]/g, ''),
      'alpha_numeric',
      1,
      10
    );
  };

  const handleOtpInputChange = (e) => {
    props.handleInputChange(
      'otp',
      e.target.value.replace(/[^0-9]/g, ''),
      'alpha_numeric',
      1,
      4
    );
  };
  const onContactUsClick = () => {
    sendWhatsappMessage(`Hi ${props?.storeInfo?.store_name},\n
                         I'm unable to access your website
                         ${props?.storeInfo?.store_url}`);
  };

  return (
    <div className="flex justify-center">
      <div className={styles.desktopView}>
        {props.OTPsent ? (
          <>
            <div>
              <img src={props?.storeInfo?.logo_image} height="44px" width="44px" />
              <p className="mv0 pt16px f16px fw5 black-color">
                Welcome to {props.storeInfo?.store_info?.name}
              </p>
              <p className="mv0 f22px fw5 c1C1C1C pt32px">OTP sent to {props.phone}</p>
            </div>
            <input
              className={
                props.invalidOtp ? styles.formControlOtpInvalid : styles.formControlOtp
              }
              value={props.OTP}
              placeholder="Enter 4 digit OTP"
              onChange={handleOtpInputChange}
            />
            <>
              <div style={{ width: 300, transform: 'translate(343px , 18px)' }}>
                {!props.isTimeUp ? (
                  <span
                    className="timer mt20px db"
                    style={{
                      transform: 'translate(133px , -18px)',
                    }}
                  >
                    {`0:${props.timer}`}
                  </span>
                ) : (
                  <span
                    style={{
                      width: 300,
                      color: '#6C6C6C',
                    }}
                  >
                    Did not receive OTP?
                  </span>
                )}
              </div>
              {props.isTimeUp && (
                <div
                  className="pointer fw7 f14px relative z-1"
                  style={{
                    transform: 'translate(425px , 20px)',
                  }}
                  onClick={() => props.resendOTP()}
                >
                  Send Again
                </div>
              )}
            </>
            <div
              style={
                props.invalidOtp
                  ? { color: 'red', transform: 'translateY(-19px)' }
                  : {
                      color: 'red',
                      transform: 'translateY(-19px)',
                      visibility: 'hidden',
                    }
              }
            >
              Invalid OTP
            </div>
            <div
              className="flex items-end justify-between"
              style={{ transform: 'translateY(-20px)' }}
            >
              <div className="flex items-center">
                <p
                  className="mv0 flex c2F80ED pointer f14px fw5"
                  style={{ paddingBottom: '1.38rem' }}
                  onClick={props.toggleOTPsent}
                >
                  Change number?
                </p>
              </div>
              <div className="flex" style={{ transform: 'translate(16px , 0)' }}>
                <Button
                  backgroundColor={
                    props.OTP.length === 4 && !props.invalidOtp ? '#000000' : '#00000033'
                  }
                  roundness={props.storeInfo?.theme?.roundness}
                  style={{ borderRadius: '4rem', borderWidth: '0px' }}
                  py="21px"
                  mx="auto"
                  mt="81px"
                  pr="4rem"
                  pl="3rem"
                  fontSize={18}
                  className={props.OTP.length === 0 ? 'cursor-auto' : ''}
                  isDisable={props.OTP.length !== 4}
                  onClick={() => props.submitVerifyOTP()}
                  label="VERIFY"
                />
                <div
                  style={{ transform: 'translate(-58px, 105px)' }}
                  onClick={() => props.submitVerifyOTP()}
                  className="pointer"
                >
                  <OtpRightArrow />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <img src={props?.storeInfo?.logo_image} height="44px" width="44px" />
              <p className="mv0 pt16px f16px fw5 black-color">
                Welcome to {props.storeInfo?.store_info?.name}
              </p>
              <p className="mv0 f22px fw5 c1C1C1C pt32px">Login using Mobile Number</p>
            </div>
            <input
              className={styles.formControl}
              value={props.phone}
              placeholder="Enter your mobile Number"
              onChange={handleMobileInputChange}
            />
            <div>
              {props.memberOnlyAccessError ? (
                <div className="flex items-start mt16px">
                  <img
                    src="/assets/images/red-info-icon.svg"
                    width="14px"
                    height="14px"
                  />
                  <p className="mv0 f14px fw4 pl10px" style={{ color: '#F54C52' }}>
                    Sorry, you don’t have permission to access this website.
                  </p>
                </div>
              ) : null}
            </div>
            <p
              className={`c464646 f14px fw5 mv0 ${
                props.memberOnlyAccessError ? 'pt12px' : 'pt20px'
              }`}
            >
              For any query,{' '}
              <button
                className="c2F80ED"
                style={{ border: 'none', cursor: 'pointer', backgroundColor: 'white' }}
                onClick={onContactUsClick}
              >
                Contact us
              </button>
            </p>
            <div className="flex justify-end">
              <div className="flex" style={{ transform: 'translate(16px , -22px)' }}>
                <Button
                  style={{ borderRadius: '4rem', borderWidth: '0px' }}
                  backgroundColor={
                    props.phone.length === 10 && !props.memberOnlyAccessError
                      ? '#000000'
                      : '#00000033'
                  }
                  roundness={props.storeInfo?.theme?.roundness}
                  width="174px"
                  py="24px"
                  mx="auto"
                  whiteSpace="nowrap"
                  mt={props.memberOnlyAccessError ? '59px' : '85px'}
                  pr="4rem"
                  pl="2.5rem"
                  fontSize={18}
                  isDisable={
                    (props.phone && props.phone.length !== 10) ||
                    !props.phone ||
                    props.memberOnlyAccessError
                  }
                  onClick={() => props.setPhoneNumber()}
                  label="GET OTP"
                />
                <div
                  style={{
                    transform: props.memberOnlyAccessError
                      ? 'translate(-43px, 85px)'
                      : 'translate(-43px, 112px)',
                  }}
                  onClick={() => props.setPhoneNumber()}
                  className="pointer"
                >
                  <OtpRightArrow />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DesktopView;
